import React from "react";
import { Box, Typography } from "@mui/material";
import { MARK_DOT, REUSABLE_LABEL, ReusableDot } from "./BulkMarks";

// 見本はチェックボックスに見立てた四角に、セルと同じ寸法で印を付ける
const SWATCH_SIZE = 14;

/** チェック列の印の凡例。右上の藍の点はリユース候補（自社取得済みは「取得済」の文字そのものが印なので見本が要らない） */
export const BulkMarkLegend: React.FC = React.memo(() => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <Box
      sx={{
        position: "relative",
        width: SWATCH_SIZE,
        height: SWATCH_SIZE,
        borderRadius: "2px",
        border: "2px solid",
        borderColor: "text.secondary",
      }}
    >
      <ReusableDot
        sx={{
          left: "auto",
          right: -MARK_DOT.size / 2,
          top: -MARK_DOT.size / 2,
        }}
      />
    </Box>
    <Typography variant="body2">{REUSABLE_LABEL}</Typography>
  </Box>
));
BulkMarkLegend.displayName = "BulkMarkLegend";
